import { Component } from '@angular/core';

@Component({
  selector: 'app-about',
  standalone: true,
  templateUrl: './about.html',
  styleUrl: './about.scss',
})
export class AboutComponent {
  tags = ['Grupos pequeños', 'Sin Experiencia', 'merienda y materiales', 'Enfoque emocional'];

  scrollToTalleres() {
    const el = document.getElementById('talleres');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
